import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DecimalPipeWrapper } from '../../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';
import { FeatureConnectionService } from '../../../shared/services/feature-connection.service';
import { UnitsAdapter } from '../../services/units-adapter/units.adapter';
import { BooleanValueStrategy } from './boolean-value-strategy';
import { DeviceCascadeMemberIdStrategy } from './device.cascade.memberId-strategy';
import {
  FEATURE_VALUE_STRATEGIES_TOKEN,
  FeatureValueStrategy,
} from './feature-value-strategy.model';
import { NumberValueEnergyUnitsStrategy } from './number-value-energy-units-strategy';
import { NumberValueImperialUnitsStrategy } from './number-value-imperial-units-strategy';
import { NumberValueStrategy } from './number-value-strategy';
import { StringValueStrategy } from './string-value-strategy';
import { Value2Pipe } from './value2.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [Value2Pipe],
  providers: [
    FeatureConnectionService,
    DecimalPipeWrapper,
    {
      provide: FEATURE_VALUE_STRATEGIES_TOKEN,
      useFactory: valueStrategiesFactory,
      deps: [DecimalPipeWrapper, UnitsAdapter],
    },
  ],
  exports: [Value2Pipe],
})
export class ValueStrategyModule {}

export function valueStrategiesFactory(
  decimalPipeWrapper: DecimalPipeWrapper,
  unitsAdapter: UnitsAdapter
): FeatureValueStrategy[] {
  return [
    // feature is handled by first strategy for which supports returns true
    // order matters!
    new DeviceCascadeMemberIdStrategy(),
    new StringValueStrategy(),
    new NumberValueImperialUnitsStrategy(unitsAdapter),
    new NumberValueEnergyUnitsStrategy(decimalPipeWrapper),
    new NumberValueStrategy(decimalPipeWrapper),
    new BooleanValueStrategy(),
  ];
}
